import { Link } from "react-router-dom";
import { useMotivation } from "@/hooks/useMotivation";
import { useGoals } from "@/hooks/useGoals";

function daysUntil(dateStr: string): number | null {
  if (!dateStr) return null;
  const target = new Date(`${dateStr}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.ceil((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export default function MotivationSummary() {
  const { data, loading } = useMotivation();
  const { goal } = useGoals();

  const daysLeft = goal.targetExamDate ? daysUntil(goal.targetExamDate) : null;

  if (loading) {
    return <div className="rounded-lg border border-background-200 bg-background-50 p-5 h-40 animate-pulse" />;
  }

  return (
    <Link
      to="/ogrenci/motivasyon"
      className="block rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
            <i className="ri-fire-line text-xl" aria-hidden="true"></i>
          </span>
          <div>
            <p className="text-lg font-heading font-bold text-foreground-950">{data.streak} gün seri</p>
            <p className="text-xs text-foreground-500">
              Seviye {data.level} · {data.levelTitle}
            </p>
          </div>
        </div>

        {daysLeft !== null && daysLeft >= 0 && (
          <div className="text-right">
            <p className="text-lg font-heading font-bold text-accent-700">{daysLeft}</p>
            <p className="text-xs text-foreground-500">gün kaldı</p>
          </div>
        )}
      </div>

      <div className="mt-4 h-2 w-full rounded-full bg-background-100 overflow-hidden">
        <div
          className="h-full rounded-full bg-primary-500"
          style={{ width: `${data.levelProgress}%` }}
        />
      </div>
      <p className="mt-2 text-xs text-foreground-500 flex items-center justify-between">
        <span>{data.xp.toLocaleString("tr-TR")} XP</span>
        <span className="flex items-center gap-1 text-primary-700">
          Motivasyon Merkezi
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </span>
      </p>
    </Link>
  );
}